import type { HydratedUser } from "@packsize/identity-api-sdk";

export const hasAnyRole = (user: HydratedUser | null | undefined, roles: string[]): boolean => {
	if (!user) {
		return false;
	}

	if (roles.length === 0) {
		return false;
	}

	const normalizedUserPermissions = user.permissions.map((permission) => permission.toLowerCase());

	return roles.some((role) => normalizedUserPermissions.includes(role.toLowerCase()));
};
